import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

export default new VueRouter({
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/login",
    },
    // {
    //   name: 'index',
    //   path: '/',
    //   meta: { layout: 'index' },
    //   component: () => import("@/components/index")
    // },
    {
      name: "Dashboard",
      path: "/dashboard",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/dashboard"),
    },
    {
      name: "TransactionList",
      path: "/transactionList",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/transactionList"),
    },
    {
      name: "myProfile",
      path: "/myProfile",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/myProfile"),
    },
    {
      name: "addPhoneNumber",
      path: "/addPhoneNumber",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/addPhoneNumber"),
    },
    {
      name: "changePassword",
      path: "/changePassword",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/changePassword"),
    },
    {
      name: "assets",
      path: "/assets",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/assets"),
    },
    {
      name: "storeSetting",
      path: "/storeSetting",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/storeSetting"),
    },
    {
      name: "walletAddressesSetting",
      path: "/walletAddressesSetting",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/walletAddressesSetting"),
    },
    {
      name: "paymentProtocolSetting",
      path: "/paymentProtocolSetting",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/paymentProtocolSetting"),
    },
    {
      name: "withdrawSetting",
      path: "/withdrawSetting",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/withdrawSetting"),
    },
    {
      name: "customerWithdrawal",
      path: "/customerWithdrawal",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/customerWithdrawal"),
    },
    {
      name: "disperseWalletAddressSetting",
      path: "/disperseWalletAddressSetting",
      meta: { requiresAuth: true, layout: "merchant" },
      component: () => import("@/components/disperseWalletAddressSetting"),
    },
    {
      name: "login",
      path: "/login",
      component: () => import("@/components/pages/login"),
    },
    {
      name: "signup",
      path: "/signup",
      component: () => import("@/components/pages/signup"),
    },
    {
      name: "verify email address",
      path: "/emailVerify/:token",
      component: () => import("@/components/emailVerify"),
    },
    {
      name: "QR Code Payment page",
      path:
        "/pay/:address/:cryptoAmount/:amount/:currency/:tokenAddress/:merchantId/:orderId",
      component: () => import("@/components/pay"),
    },
    {
      name: "forget password",
      path: "/forgetPassword",
      component: () => import("@/components/forgetPassword"),
    },
    {
      name: "reset password",
      path: "/resetPassword/:token",
      component: () => import("@/components/resetPassword"),
    },
  ],
});
